import Compressor from "compressorjs";

function useImageCompressor() {
  const compressImage = async (image) => {
    return new Promise((resolve, reject) => {
      new Compressor(image, {
        quality: 0.7,
        maxWidth: 1200,
        maxHeight: 1200,
        success: (compressedResult) => {
          resolve(compressedResult);
        },
        error: (error) => {
          resolve(image);
        },
      });
    });
  };

  return { compressImage };
}

export default useImageCompressor;
